<template>
  <vs-table
    :data="tastingFormList"
    class="table-dark-inverted table-auto vs-con-loading__container"
  >
    <template slot="thead">
      <vs-th width="15%" class="text-xs">DATE</vs-th>
      <vs-th width="15%" class="text-xs">DONE BY</vs-th>
      <vs-th width="10%" class="text-xs">STATUS</vs-th>
      <vs-th width="10%" class="text-xs">ACTION</vs-th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr
        class="text-sm"
        style="cursor: pointer"
        :key="indextr"
        v-for="(tr, indextr) in data"
      >
        <vs-td>{{ __dateTimeFormatter(tr.created_at) }}</vs-td>
        <vs-td>{{ tr.done_by.name }}</vs-td>
        <vs-td>{{ tr.status }}</vs-td>

        <vs-td>
          <div class="vx-row">
            <vx-tooltip
              class="ml-2"
              text="View Taste Panel"
              position="left"
              v-can="'view-quality-control-tastings'"
            >
              <vs-button
                @click.stop="viewTasteForm(tr.id)"
                color="warning"
                size="small"
                type="filled"
                icon-pack="feather"
                icon="icon-eye"
              />
            </vx-tooltip>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");


export default {
  name: "TastingFormTable",

  props: {
    batchId: { type: Number, required: true },
    batchType: { type: String, required: true },
  },

  data() {
    return {
      tastingFormList: [],
    };
  },

  watch: {
    batchId: "loadData",
    batchType: "loadData",
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      if (!this.batchId || !this.batchType) return;

      try {
        const response =
          await TriangleTestsRepository.getListOfQualityControlTestings(
            `filter[batch_id]=${this.batchId}&filter[batch_type]=${this.batchType}`
          );
        this.tastingFormList = response.data.data;
      } catch (e) {
        console.error("Failed to fetch tastings", e);
      }
    },

    viewTasteForm(id) {
      const route = this.$router.resolve({
        path: `/pages/taste-panels?open=${id}`,
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>
